import { pad3 } from "@/lib/format";
import type { Mastery, Word } from "@/types/lex";
import { POS } from "./POS";
import { MASTERY_DOT } from "./status";

interface WordRowProps {
  word: Word;
  mastery: Mastery;
  onOpen: (wordIndex: number) => void;
}

export function WordRow({ word, mastery, onOpen }: WordRowProps) {
  return (
    <button className="word-row" onClick={() => onOpen(word.index)}>
      <span className="t-mono word-row__idx">{pad3(word.index)}</span>
      <span className={`dot dot--${MASTERY_DOT[mastery]}`} style={{ marginRight: 4 }} />
      <span className="t-display word-row__word">{word.word}</span>
      <span className="t-mono word-row__ipa">/{word.ipa}/</span>
      <POS value={word.pos} />
      <span className="word-row__meaning t-display italic">{word.meaning_vi}</span>
      <span className="word-row__arrow">→</span>
    </button>
  );
}
